import { useCallback } from 'react';
import { invoicesService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Invoice } from '../types';

export function useInvoices(
  options?: ResourceQueryOptions
): ResourceState<Invoice> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      invoicesService.getAll(opts) as unknown as Promise<{ data: Invoice[]; meta?: any }>,
    []
  );
  return useResourceCollection<Invoice>(fetchFn, options);
}

export function useInvoice(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Invoice> {
  const resourceId = id;
  const fetchFn = useCallback(
    (invoiceId: string | number, opts?: ResourceQueryOptions) =>
      invoicesService.getById(invoiceId, opts) as unknown as Promise<Invoice>,
    []
  );
  return useResourceById<Invoice>(fetchFn, resourceId, options);
}

export function useCreateInvoice(
  onSuccess?: (data: Invoice) => void
): MutationState<Invoice> {
  const createFn = useCallback(
    (data: any) => invoicesService.create(data) as unknown as Promise<Invoice>,
    []
  );
  return useCreateResource<Invoice>(createFn, onSuccess);
}

export function useUpdateInvoice(
  onSuccess?: (data: Invoice) => void
): MutationState<Invoice> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return invoicesService.update(id, data) as unknown as Promise<Invoice>;
    },
    []
  );
  return useUpdateResource<Invoice>(updateFn, onSuccess);
}

/**
 * Delete invoice using documentId
 * @param data - Full invoice object containing documentId
 */
export function useDeleteInvoice(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return invoicesService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
